export default __webpack_public_path__ + "static/media/CNo.72-1.7bee7b8d.jpg";